function DownloadLink({ href, children })
{
    return <a className="fw-bold text-decoration-none text-reset" href={href} download>{children}</a>;
}

export default DownloadLink;